// extracted by css-extract-rspack-plugin
export default {"container":"MessageContainer-styles-container-3dedef4a","innerContainer":"MessageContainer-styles-innerContainer-a93c0a38"};